module.exports = __webpack_public_path__ + "static/SL11-b131ceb4c2e7bb77d72f9f8c7d3b798b.png";